import { STATUS } from "@/components/_Shared/Form/Schemas/StatusSchema";
import { TaskProps } from "@/interfaces/tasks_types";
import { FormDataType } from "../TaskForm";

export function ImportFormProps(task_data: TaskProps): FormDataType {
	// Ensure status is one of the valid STATUS values
	const validStatus =
		task_data.status &&
		STATUS.includes(task_data.status as unknown as "Active" | "Closed")
			? (task_data.status as (typeof STATUS)[number])
			: "Active";

	return {
		task_id: task_data.task_id,
		project: task_data.project_id
			? {
					value: task_data.project_id,
					label: task_data.project_name ?? "",
				}
			: null,
		title: task_data.title,
		description: task_data.description,
		completion_percentage: task_data.completion_percentage,
		category: task_data.category
			? {
					value: task_data.category,
					label: task_data.category,
				}
			: null,
		due_date: task_data.due_date,
		status: {
			value: validStatus,
			label: validStatus,
		},
		assigned_by: task_data.assigned_by_obj
			? {
					value: task_data.assigned_by_obj.email,
					label: task_data.assigned_by_obj.name,
				}
			: null,
		assigned_to: task_data.assigned_to_obj
			? {
					value: task_data.assigned_to_obj.email,
					label: task_data.assigned_to_obj.name,
				}
			: null,
		priority: task_data.priority === "Urgent",
	};
}
